<script setup lang="ts">
import { RouterView } from 'vue-router'
import ErrorBoundary from '@uiKit/components/ErrorBoundary.vue'
</script>

<template>
  <ErrorBoundary>
    <RouterView />
  </ErrorBoundary>
</template>
